import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicColor({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M15 7.97c0 1.23-.96 2.24-2.16 2.32h-2.11a.94.94 0 00-.9 1.26l.05.1.07.15c.57 1.33-.2 2.93-1.65 3.15-3.99.62-8.1-3.67-7.17-8.38a6.97 6.97 0 015.2-5.38l.26-.05.23-.05A7 7 0 0115 7.97zM7.08 2.52l-.21.04-.22.05a5.53 5.53 0 00-4.1 4.24c-.73 3.73 2.54 7.13 5.53 6.67.45-.07.73-.62.55-1.1l-.04-.1-.07-.15a2.38 2.38 0 012.05-3.32h2.11c.48 0 .87-.4.87-.88-.01-3.4-3.05-5.99-6.47-5.45zM4.25 8a.97.97 0 110 1.93.97.97 0 010-1.93zm.79-3.14a.97.97 0 110 1.93.97.97 0 010-1.93zm6.28 0a.97.97 0 110 1.93.97.97 0 010-1.93zM8.18 3.3a.97.97 0 110 1.93.97.97 0 010-1.93z" />
    </svg>
  );
}

SvgBasicColor.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicColor.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicColor svgRef={ref} {...props} />);
export default ForwardRef;
